module.exports = __webpack_public_path__ + "static/img/gift-6.fc96b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-6.png
// module id = 366
// module chunks = 140